<template>
  <div class="icons">
    <span v-for="(item,index) in icons"
    @click="toggle(index)"
    :key="index"
    :class="[item.image, {clicked: index === activeIndex}]" class="smiley">
    </span>
  </div>
</template>

<script>

const icons = [
  {
    name: 'sad',
    image: 'fal fa-frown fa-2x'
  },
  {
    name: 'meh',
    image: 'fal fa-meh fa-2x'
  },
  {
    name: 'happy',
    image: 'fal fa-smile fa-2x'
  }
]
export default {
  data: function () {
    return {
      icons,
      activeIndex: ''
    }
  },
  methods: {
    toggle: function (index) {
      this.activeIndex = index
      this.$emit('input', icons[index].name)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .smiley {
    color: #696969;
    font-weight: 100;
  }

  .icons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: 0.7rem;
    span {
      padding: 0 0.9rem;
      @include mobile {
        font-size: 2.1rem;
      }
    }
  }

  .clicked {
    color: $primary;
    font-weight: 500;
  }

</style>
